<template>
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">
        <span>Pagos</span>
      </h3>
    </div>

    <div class="card-body">
      <div class="row text-center">
        <div class="col-md-1 col-sm-1 d-none d-sm-block p-0">
          <h3>N°</h3>
        </div>
        <div class="col-md-3 col-sm-3 d-none d-sm-block p-0">
          <h3>Fecha de Pago</h3>
        </div>
        <div class="col-md-4 col-sm-4 d-none d-sm-block p-0">
          <h3>Monto (USD)</h3>
        </div>
        <div class="col-md-4 col-sm-4 d-none d-sm-block p-0">
          <h3>Monto (ARS)</h3>
        </div>
      </div>
      <div v-for="paymentNumber in range(1, order.payments)" :key="paymentNumber" class="row text-center mb-1">
        <div class="col-md-1 col-sm-1 col-2 p-0">
          <small class="d-inline-block d-sm-none">#</small>
          {{ paymentNumber }}
        </div>
        <div class="col-8 offset-2 d-inline-block d-sm-none p-0"></div>
        <div class="col-md-3 col-sm-3 col-4 p-0">
          <small>{{ paymentDate(paymentNumber) | date('DD/MM/YYYY') }}</small>
        </div>
        <div class="col-md-4 col-sm-4 col-4 p-0">
          {{ paymentAmountInUSD(paymentNumber) | toCurrencyUSD }}
        </div>
        <div class="col-md-4 col-sm-4 col-4 p-0">
          {{ paymentAmountInARS(paymentNumber) | toCurrencyARS }}
        </div>
      </div>
      <div class="row text-center mt-4 mb-3">
        <div class="col-sm-4 col-xs-12 text-center"><h2>TOTAL</h2></div>
        <div class="col-sm-4 col-xs-12 text-lg">{{ total | toCurrencyUSD }}</div>
        <div class="col-sm-4 col-xs-12 text-lg">{{ totalInArs | toCurrencyARS }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersMixin from '@/mixins/ordersMixin';
import moment from 'moment';
import { getDollarQuote } from '@/util/orders';

export default {
  mixins: [OrdersMixin],
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  methods: {
    range(start, end) {
      let arr = [];
      for (let i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    },

    paymentAmount(paymentNumber, total) {
      let paymentAmount = total / this.order.payments;
      if (paymentNumber === this.order.payments) {
        const diff = total - paymentAmount * this.order.payments;
        return diff + paymentAmount;
      }
      return paymentAmount;
    },

    paymentAmountInUSD(paymentNumber) {
      return this.paymentAmount(paymentNumber, this.total);
    },

    paymentAmountInARS(paymentNumber) {
      return this.paymentAmount(paymentNumber, this.total * getDollarQuote(this.order));
    },

    paymentDate(paymentNumber) {
      let startDate = this.order.firstPaymentDate;
      let paymentDate = moment(startDate); // moment(...) can also be used to parse dates in string format
      return paymentDate.add(paymentNumber - 1, 'months');
    },
  },
};
</script>
